<template lang="html">
<div class="centered-flex">
      <div class="content main__content col-md-12">
        <div id="login-page" class="login-page guest-forms"><br>
          <div>
<!--
            <login-form-block :disable-redirect="true"
                              :autologin="true"></login-form-block>
-->

            <login-form-block :disable-redirect="false"
                              :backurl="backUrl"
                              :oauth="true"></login-form-block>
          </div>
        </div>

    </div>
</div>
</template>

<script lang="ts" setup>

import {reactive, ref} from "vue";
import LoginFormBlock from "@/views/pages/auth/login/LoginFormBlock.vue";
const backUrl = ref('https://example.com/test/page')

</script>

<style scoped lang="less">
.centered-flex {

  width: 100%;

}
</style>
